import useBulkWalletEventCollectionData from '../../hooks/useBulkWalletEventCollectionData'
import CollectionRelatedFirstEventDataFetcher from './CollectionRelatedEventsDataFetcher'

interface Props {
  collectionIds: number[]
}

const EventCollectionDataFetcher: React.FC<Props> = (props: Props) => {
  const { collectionIds } = props

  useBulkWalletEventCollectionData({ collectionIds })

  return (
    <>
      {collectionIds.map((elem, key) => {
        return <CollectionRelatedFirstEventDataFetcher key={key} collectionId={elem} />
      })}
    </>
  )
}

export default EventCollectionDataFetcher
